import { BusEvent } from '@web/common';

export class WarehouseReleaseCreatedBusEvent extends BusEvent {}
